<template>
  <div class="login-page">
    <div class="login-page__aurora"></div>
    <div class="login-page__grid"></div>
    <div class="login-page__beam login-page__beam--left"></div>
    <div class="login-page__beam login-page__beam--right"></div>
    <div class="login-page__particles">
      <span v-for="item in particles" :key="item.id" class="login-page__particle" :style="item.style"></span>
    </div>
    <div class="login-page__orb login-page__orb--left"></div>
    <div class="login-page__orb login-page__orb--right"></div>
    <div class="login-page__scan"></div>

    <div class="login-page__panel">
      <!-- 左侧品牌区 -->
      <section class="login-hero">
        <div class="login-hero__badge">
          <span></span>
          EQUITY FEE MANAGEMENT PLATFORM
        </div>
        <h1>权益金<br>管理平台</h1>
        <p>
          统一管理商户，
          让商户监管与订单审核在一个清晰的数字界面里高效运转。
        </p>
        <div class="login-hero__metrics">
          <!-- <div v-for="item in heroMetrics" :key="item.label" class="login-hero__metric">
            <strong>{{ item.value }}</strong>
            <span>{{ item.label }}</span>
          </div> -->
        </div>
      </section>

      <!-- 右侧登录卡片 -->
      <section class="login-card">
        <div class="login-card__glow"></div>
        <div class="login-card__title-block">
          <div class="login-card__eyebrow">SECURE ACCESS</div>
          <h2>账号登录</h2>
        </div>
        <el-form ref="formRef" :model="form" :rules="rules" label-position="top" @submit.native.prevent>
          <el-form-item label="账号" prop="auAccount">
            <el-input v-model.trim="form.auAccount" prefix-icon="el-icon-user" placeholder="请输入账号"></el-input>
          </el-form-item>
          <el-form-item label="密码" prop="auPw">
            <el-input v-model.trim="form.auPw" prefix-icon="el-icon-lock" type="password" placeholder="请输入密码" show-password></el-input>
          </el-form-item>
          <el-button type="primary" :loading="submitting" class="login-page__submit" @click="handleLogin">
            进入系统
          </el-button>
        </el-form>
        <div class="login-card__footer">
          <span></span>
         订单监管 / 商户 /用户
        </div>
      </section>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LoginPage',
  data () {
    return {
      submitting: false,
      form: {
        auAccount: '',
        auPw: ''
      },
      heroMetrics: [
        { value: '01', label: '资金管理' },
        { value: '24h', label: '实时监控' },
        { value: '100%', label: '合规审计' }
      ],
      particles: [
        { id: 1, style: { left: '10%', top: '22%', animationDelay: '0s', animationDuration: '9s' } },
        { id: 2, style: { left: '22%', top: '68%', animationDelay: '1.2s', animationDuration: '11s' } },
        { id: 3, style: { left: '38%', top: '16%', animationDelay: '2.1s', animationDuration: '10s' } },
        { id: 4, style: { left: '58%', top: '76%', animationDelay: '0.8s', animationDuration: '12s' } },
        { id: 5, style: { left: '72%', top: '24%', animationDelay: '1.8s', animationDuration: '9.5s' } },
        { id: 6, style: { left: '86%', top: '58%', animationDelay: '2.6s', animationDuration: '11.5s' } }
      ],
      rules: {
        auAccount: [{ required: true, message: '请输入账号', trigger: 'blur' }],
        auPw: [{ required: true, message: '请输入密码', trigger: 'blur' }]
      }
    }
  },
  methods: {
    handleLogin () {
      this.$refs.formRef.validate(async valid => {
        if (!valid) return
        this.submitting = true
        try {
          await this.$store.dispatch('user/login', this.form)
          // 登录成功后进入加载页，由加载页统一处理权限获取和路由跳转
          this.$router.replace('/loading')
          this.$message.success('登录成功，正在进入工作台')
        } catch (error) {
          // 错误提示已在请求层处理
        } finally {
          this.submitting = false
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.login-page {
  position: relative;
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  padding: 40px 28px;
  background:
    radial-gradient(circle at 14% 18%, rgba(44, 82, 130, 0.22), transparent 24%),
    radial-gradient(circle at 88% 16%, rgba(214, 158, 46, 0.18), transparent 20%),
    radial-gradient(circle at 50% 110%, rgba(44, 82, 130, 0.12), transparent 28%),
    linear-gradient(135deg, #f8fbfd 0%, #edf4f8 42%, #e6f0f4 100%);
}

.login-page__aurora, .login-page__grid, .login-page__scan, .login-page__orb, .login-page__beam, .login-page__particles {
  position: absolute; pointer-events: none;
}

.login-page__aurora {
  inset: -12% -10% auto; height: 420px;
  background:
    radial-gradient(circle at 18% 40%, rgba(44, 82, 130, 0.18), transparent 32%),
    radial-gradient(circle at 50% 12%, rgba(255, 255, 255, 0.7), transparent 28%),
    radial-gradient(circle at 82% 30%, rgba(214, 158, 46, 0.16), transparent 30%);
  filter: blur(14px); opacity: 0.95;
}

.login-page__grid {
  inset: 0;
  background-image:
    linear-gradient(rgba(44, 82, 130, 0.05) 1px, transparent 1px),
    linear-gradient(90deg, rgba(44, 82, 130, 0.05) 1px, transparent 1px);
  background-size: 34px 34px;
  mask-image: radial-gradient(circle at center, #000 42%, transparent 86%);
  opacity: 0.8;
}

.login-page__beam {
  position: absolute; width: 38vw; max-width: 520px; min-width: 260px; height: 180px;
  border-radius: 999px; filter: blur(12px); opacity: 0.5; transform: rotate(-18deg);
  background: linear-gradient(90deg, rgba(255, 255, 255, 0), rgba(255, 255, 255, 0.72), rgba(255, 255, 255, 0));
}

.login-page__beam--left { left: -6%; top: 18%; animation: beamFloatLeft 14s ease-in-out infinite; }
.login-page__beam--right { right: -8%; bottom: 14%; transform: rotate(18deg); animation: beamFloatRight 16s ease-in-out infinite; }

.login-page__particles { inset: 0; }
.login-page__particle {
  position: absolute; width: 8px; height: 8px; border-radius: 50%;
  background: radial-gradient(circle, rgba(255, 255, 255, 0.95), rgba(214, 158, 46, 0.3) 62%, rgba(214, 158, 46, 0));
  box-shadow: 0 0 18px rgba(214, 158, 46, 0.24);
  animation: particleFloat linear infinite;
}

.login-page__scan {
  inset: -30% 0 auto; height: 240px;
  background: linear-gradient(180deg, rgba(44, 82, 130, 0), rgba(44, 82, 130, 0.08), rgba(44, 82, 130, 0));
  animation: scanMove 8s linear infinite;
}

.login-page__orb { border-radius: 50%; filter: blur(12px); }
.login-page__orb--left { width: 320px; height: 320px; left: -80px; top: 90px; background: radial-gradient(circle, rgba(44, 82, 130, 0.22), transparent 68%); }
.login-page__orb--right { width: 280px; height: 280px; right: -30px; bottom: 40px; background: radial-gradient(circle, rgba(214, 158, 46, 0.18), transparent 70%); }

.login-page__panel {
  position: relative; z-index: 1; width: min(1240px, 100%);
  display: grid; grid-template-columns: minmax(0, 1.2fr) 430px; gap: 38px; align-items: center;
}

.login-hero { padding: 52px 0 52px 28px; color: #35506c; }

.login-hero__badge {
  width: fit-content; display: inline-flex; align-items: center; gap: 10px;
  padding: 10px 16px; border: 1px solid rgba(44, 82, 130, 0.16); border-radius: 999px;
  background: rgba(255, 255, 255, 0.62); box-shadow: 0 12px 32px rgba(44, 82, 130, 0.08);
  color: #42617f; font-size: 12px; letter-spacing: 0.16em;
}

.login-hero__badge span { width: 8px; height: 8px; border-radius: 50%; background: #d69e2e; box-shadow: 0 0 16px rgba(214, 158, 46, 0.58); }

.login-hero h1 { margin: 28px 0 0; font-size: 58px; line-height: 1.08; letter-spacing: 0.03em; color: #243447; text-shadow: 0 10px 30px rgba(44, 82, 130, 0.1); }
.login-hero p { margin: 24px 0 0; max-width: 580px; font-size: 16px; line-height: 1.95; color: rgba(53, 80, 108, 0.76); }

.login-hero__metrics { margin-top: 42px; display: grid; grid-template-columns: repeat(3, minmax(0, 1fr)); gap: 18px; max-width: 720px; }

.login-hero__metric {
  position: relative; padding: 20px 20px 18px;
  border: 1px solid rgba(117, 145, 173, 0.16); border-radius: 20px;
  background: rgba(255, 255, 255, 0.66); box-shadow: 0 14px 36px rgba(38, 64, 92, 0.08);
  backdrop-filter: blur(14px);
}

.login-hero__metric::after {
  content: ''; position: absolute; left: 18px; right: 18px; top: 0; height: 1px;
  background: linear-gradient(90deg, transparent, rgba(44, 82, 130, 0.4), transparent);
}

.login-hero__metric strong { display: block; font-size: 28px; font-weight: 700; color: #2c5282; }
.login-hero__metric span { display: block; margin-top: 10px; font-size: 13px; letter-spacing: 0.08em; color: rgba(53, 80, 108, 0.68); }

.login-card {
  position: relative; overflow: hidden; padding: 34px 30px 28px;
  border: 1px solid rgba(117, 145, 173, 0.18); border-radius: 28px;
  background: linear-gradient(180deg, rgba(255, 255, 255, 0.9), rgba(255, 255, 255, 0.78));
  box-shadow: 0 30px 70px rgba(38, 64, 92, 0.14), inset 0 1px 0 rgba(255, 255, 255, 0.72);
  backdrop-filter: blur(18px);
}

.login-card::before {
  content: ''; position: absolute; inset: 0; border-radius: inherit; padding: 1px;
  background: linear-gradient(135deg, rgba(255, 255, 255, 0.8), rgba(44, 82, 130, 0.18), rgba(214, 158, 46, 0.14));
  -webkit-mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0);
  -webkit-mask-composite: xor; mask-composite: exclude; pointer-events: none;
}

.login-card__glow {
  position: absolute; width: 240px; height: 240px; right: -100px; top: -90px; border-radius: 50%;
  background: radial-gradient(circle, rgba(44, 82, 130, 0.22), transparent 72%);
}

.login-card__glow::after {
  content: ''; position: absolute; width: 170px; height: 170px; right: 42px; top: 54px; border-radius: 50%;
  background: radial-gradient(circle, rgba(214, 158, 46, 0.18), transparent 74%);
}

.login-card__title-block { position: relative; z-index: 1; }
.login-card__eyebrow { color: #d69e2e; font-size: 12px; letter-spacing: 0.18em; }
.login-card__title-block h2 { margin: 14px 0 0; font-size: 32px; color: #243447; }
.login-card__title-block p { margin: 10px 0 28px; font-size: 14px; line-height: 1.8; color: rgba(53, 80, 108, 0.72); }

.login-page ::v-deep .el-form-item__label { color: #3e5873; }
.login-page ::v-deep .el-input__inner { height: 48px; border: 1px solid rgba(117, 145, 173, 0.22); background: rgba(255, 255, 255, 0.86); color: #243447; box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.72); }
.login-page ::v-deep .el-input__inner:focus { border-color: rgba(44, 82, 130, 0.58); box-shadow: 0 0 0 3px rgba(44, 82, 130, 0.09); }
.login-page ::v-deep .el-input__prefix, .login-page ::v-deep .el-input__suffix { color: rgba(44, 82, 130, 0.58); }

.login-page__submit {
  position: relative; z-index: 1; width: 100%; margin-top: 10px; height: 48px;
  border: none; border-radius: 14px;
  background: linear-gradient(90deg, #2c5282 0%, #d69e2e 100%);
  box-shadow: 0 16px 30px rgba(44, 82, 130, 0.2); overflow: hidden;
}

.login-page__submit::after {
  content: ''; position: absolute; inset: 0;
  background: linear-gradient(110deg, rgba(255, 255, 255, 0), rgba(255, 255, 255, 0.34), rgba(255, 255, 255, 0));
  transform: translateX(-130%); transition: transform 0.5s ease;
}

.login-page__submit:hover::after, .login-page__submit:focus::after { transform: translateX(130%); }
.login-page__submit:hover, .login-page__submit:focus { transform: translateY(-1px); box-shadow: 0 22px 38px rgba(44, 82, 130, 0.24); }

.login-card__footer {
  position: relative; z-index: 1; margin-top: 24px;
  display: flex; align-items: center; gap: 12px;
  color: rgba(53, 80, 108, 0.6); font-size: 12px; letter-spacing: 0.12em;
}

.login-card__footer span { flex: 1; height: 1px; background: linear-gradient(90deg, rgba(44, 82, 130, 0.36), transparent); }

@keyframes scanMove { 0% { transform: translateY(-10%); } 100% { transform: translateY(120vh); } }
@keyframes beamFloatLeft { 0%, 100% { transform: rotate(-18deg) translate3d(0, 0, 0); } 50% { transform: rotate(-14deg) translate3d(26px, 24px, 0); } }
@keyframes beamFloatRight { 0%, 100% { transform: rotate(18deg) translate3d(0, 0, 0); } 50% { transform: rotate(22deg) translate3d(-24px, -22px, 0); } }
@keyframes particleFloat { 0% { transform: translate3d(0, 0, 0) scale(0.92); opacity: 0.22; } 35% { opacity: 0.76; } 100% { transform: translate3d(0, -34px, 0) scale(1.08); opacity: 0.08; } }

@media screen and (max-width: 1080px) { .login-page__panel { grid-template-columns: 1fr; } .login-hero { padding: 12px 0 0; } }
@media screen and (max-width: 768px) {
  .login-page { padding: 20px 16px; }
  .login-hero h1 { font-size: 42px; }
  .login-hero__metrics { grid-template-columns: 1fr; }
  .login-card { padding: 24px 20px; }
}
</style>
